import React from 'react';
import logo from '../container/image/logo.png'
import './Footer.css'
import telegramImage from '../container/image/telegram.png';
import whatsappImage from '../container/image/whatsapp.png';
import instagramImage from '../container/image/instagram.png';
import phoneImage from '../container/image/phone.png';

const Footer = () => {
    return (
        <footer className="rtl">
        <div className=" top-footer text-light">
            <div className="container">
                <div className="row justify-content-around">
                    <div className=" col-12 col-lg-6 d-block px-5 py-4">
                        <section className="info1">
                            <header className="text-center pb-5">
                                <h4 className="d-block">درباره ی ما</h4>
                                <span className="underline-border"></span>
                            </header>
                            <p className="">
                                مجموعه سه دان با هدف ارایه تمامی خدمات مورد نیاز مردم عزیزمان از
                                سال 1400 شروع به فعالیت کرده است . ما متخصصین و نیروهای تأسیساتی و تعمیراتی
                                خود را به منظور ارائه خدمات و تعمیرات در اختیار شما قرار میدهیم .
                                امید است که با کمترین هزینه ها ، بیشترین خدمات را به ملت عزیزمان ارائه کنیم.
                            </p>
                            <p className="col-8 col-sm-5 mx-auto">
                                <img src={logo} className="img-fluid" alt=""/>
                            </p>
                        </section>
                    </div>
                    <div className="col-12 col-lg-6 d-block px-5 py-4">
                        <section className="info2">
                            <header className="text-center pb-5">
                                <h4 className="d-block"> ارتباط با ما</h4>
                                <span className="underline-border"></span>
                            </header>
                            <p className="text-center" >
                                آدرس دفتر : مشهد - قاسم آباد - بلوار حجاب - حجاب 75 .
                            </p>
                            <div className="mt-lg-3">
                                <span className=" tel link-icons justify-content-end my-2">
                                    <span className="">05130000000 - 09153218853</span>
                                    <img src={phoneImage} alt=""/>
                                </span>
                                <div className="link-icons mt-auto justify-content-end mt-2">
                                    <a className="social-icon" href="https://telegram.com">
                                        <img src={telegramImage} alt=""/>
                                    </a>
                                    <a className="social-icon" href="https://telegram.com">
                                        <img src={instagramImage} alt=""/>
                                    </a>
                                    <a className="social-icon" href="https://telegram.com">
                                        <img src={whatsappImage} alt=""/>
                                    </a>
                                </div>
                            </div>
                            
                        </section>
                    </div>
            
                </div>
            </div>
        </div>
        <div className="bottom-footer text-light">
            <div className="container">
                <p className="py-4 mb-0">
                     تمامی حقوق این وبسایت متعلق به ما می باشد
                      و هرگونه کپی برداری پیگرد قانونی خواهد داشت..
                </p>
            </div>
        </div>
    </footer>
    );
};

export default Footer;
